import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { fetchQuestions } from "../../../config/data";
import axios from "axios";
import { config } from "../../../config/const";
import "./Quiz.css";

const OPTION_LABELS = ["A", "B", "C", "D", "E", "F"];

const Quiz = () => {
  const { id } = useParams();
  const [questions, setQuestions] = useState([]);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [score, setScore] = useState(0);
  const [selectedOption, setSelectedOption] = useState("");
  const [isCorrect, setIsCorrect] = useState(null);
  const [quizCompleted, setQuizCompleted] = useState(false);

  useEffect(() => {
    const LoadData = async () => {
      const data = await fetchQuestions({ id });
      setQuestions(data);
    };
    LoadData();
  }, [id]);

  const handleOptionSelect = async (option) => {
    setSelectedOption(option);
    try {
      const response = await axios.post(`${config.backend_url}/saveAttemptedQ`, {
        questionId: questions[currentQuestionIndex]._id,
        email: localStorage.getItem("email"),
        answer: option,
      });
      if (response.data.isCorrect) {
        setScore(score + 1);
        setIsCorrect(true);
      } else {
        setIsCorrect(false);
      }
    } catch (err) {
      console.error("Error saving answer:", err);
    }

    setTimeout(() => {
      if (currentQuestionIndex < questions.length - 1) {
        setCurrentQuestionIndex(currentQuestionIndex + 1);
        setSelectedOption("");
        setIsCorrect(null);
      } else {
        setQuizCompleted(true);
      }
    }, 1200);
  };

  const progress = questions.length > 0
    ? ((currentQuestionIndex + (quizCompleted ? 1 : 0)) / questions.length) * 100
    : 0;

  const scorePercent = questions.length > 0
    ? Math.round((score / questions.length) * 100)
    : 0;

  const getScoreEmoji = () => {
    if (scorePercent >= 80) return "🎉";
    if (scorePercent >= 50) return "👍";
    return "📚";
  };

  const getScoreMessage = () => {
    if (scorePercent >= 80) return "Excellent! You really understood the story!";
    if (scorePercent >= 50) return "Good job! You got most of it right.";
    return "Keep reading! Try the story again for a better score.";
  };

  return (
    <div className="quiz-page">
      <div className="quiz-container">
        {/* Header */}
        <div className="quiz-header">
          <span className="quiz-icon">🧠</span>
          <h2 className="quiz-title">Story Quiz</h2>
        </div>

        {!quizCompleted ? (
          questions.length > 0 ? (
            <>
              {/* Progress */}
              <div className="quiz-progress">
                <div className="quiz-progress-text">
                  <span>Question {currentQuestionIndex + 1} of {questions.length}</span>
                  <span className="quiz-score-badge">{score} correct</span>
                </div>
                <div className="quiz-progress-bar">
                  <div
                    className="quiz-progress-fill"
                    style={{ width: `${progress}%` }}
                  />
                </div>
              </div>

              {/* Question Card */}
              <div className="quiz-question-card">
                <div className="quiz-question-number">Q{currentQuestionIndex + 1}</div>
                <p className="quiz-question-text">
                  {questions[currentQuestionIndex].question}
                </p>
              </div>

              {/* Options */}
              <div className="quiz-options">
                {questions[currentQuestionIndex].options.map((option, index) => {
                  let stateClass = "";
                  if (selectedOption === option) {
                    stateClass = isCorrect ? "correct" : "incorrect";
                  }
                  return (
                    <button
                      key={index}
                      className={`quiz-option ${stateClass}`}
                      onClick={() => handleOptionSelect(option)}
                      disabled={selectedOption !== ""}
                    >
                      <span className="quiz-option-label">{OPTION_LABELS[index]}</span>
                      <span className="quiz-option-text">{option}</span>
                      {selectedOption === option && (
                        <span className="quiz-option-icon">
                          {isCorrect ? "✓" : "✗"}
                        </span>
                      )}
                    </button>
                  );
                })}
              </div>
            </>
          ) : (
            <div className="quiz-loading">
              <div className="quiz-loading-spinner"></div>
              <p>Loading questions...</p>
            </div>
          )
        ) : (
          /* Score Screen */
          <div className="quiz-score-screen">
            <div className="quiz-score-emoji">{getScoreEmoji()}</div>
            <h3 className="quiz-score-title">Quiz Complete!</h3>
            <div className="quiz-score-ring">
              <span className="quiz-score-number">{score}</span>
              <span className="quiz-score-divider">/</span>
              <span className="quiz-score-total">{questions.length}</span>
            </div>
            <p className="quiz-score-percent">{scorePercent}% correct</p>
            <p className="quiz-score-message">{getScoreMessage()}</p>
            <Link to={`/story/${id}`} className="quiz-back-btn">
              ← Back to Story
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default Quiz;
